export class ComponentUrls {
    public static readonly HubUrl: string = '/hubs/notification';
    public static readonly QsViewPersonId: string = 'view-p';
    public static readonly QsToken: string = 'token';
    public static readonly QsImpersonatedPersonId: string = 'impersonate-p';
    public static readonly HubTokenQueryString: string = '?bearerToken=';
}

export class SignalRGroups {
    public static readonly Job: string = ':Internal:JOB';
}